import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getCompanyCredits } from "../../Store/Thunk";
import Col from "react-bootstrap/Col";
import { Carousel } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import ApplicationCard from "./ApplicationCard";
import ApplicationCardContent from "./ApplicationCardContent";
import IconSvg from "../../../../SharedComponents/IconSvg";
import ApplicationCardInfoModal from "./ApplicationCardInfoModal";
import PerfectScrollbar from "react-perfect-scrollbar";

const ApplicationCardList = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.auth.user.companyUser.company.companyId);
  const companyCredits = useSelector((state) => state.adminDash.companyCredits);
  const [carouselItems, setCarouselItems] = useState([]);
  const [carouselKey, setCarouselKey] = useState("unset");
  const [selectedApplication, setSelectedApplication] = useState(null);

  useEffect(() => {
    updateColumns();
    window.addEventListener("resize", updateColumns);

    return () => window.removeEventListener("resize", updateColumns);
  }, [companyCredits]);

  useEffect(() => {
    if (companyCredits === undefined) {
      dispatch(getCompanyCredits({ companyId }));
    }
  }, [companyId]);

  const updateColumns = () => {
    const width = window.innerWidth;

    if (companyCredits && companyCredits.length > 0) {
      //We set the keys in order to unmount and remount the component. Causing it to go back to slide 1.
      if (width >= 2000) {
        if (carouselKey !== "xxxl") setCarouselKey("xxxl");
        setCarouselItems(groupIntoBundles(companyCredits, 6)); // For xxxl
      } else if (width >= 1400) {
        if (carouselKey !== "xxl") setCarouselKey("xxl");
        setCarouselItems(groupIntoBundles(companyCredits, 4)); // For xxl
      } else if (width >= 1200) {
        if (carouselKey !== "xl") setCarouselKey("xl");
        setCarouselItems(groupIntoBundles(companyCredits, 3)); // For xl
      } else if (width >= 992) {
        if (carouselKey !== "lg") setCarouselKey("lg");
        setCarouselItems(groupIntoBundles(companyCredits, 3)); // For lg
      } else if (width >= 768) {
        if (carouselKey !== "md") setCarouselKey("md");
        setCarouselItems(groupIntoBundles(companyCredits, 2)); // For md
      } else if (width >= 576) {
        if (carouselKey !== "sm") setCarouselKey("sm");
        setCarouselItems(groupIntoBundles(companyCredits, 2)); // For sm
      } else {
        if (carouselKey !== "xs") setCarouselKey("xs");
        setCarouselItems(groupIntoBundles(companyCredits, 1)); // For xs
      }
    }
  };

  const groupIntoBundles = (items, bundleSize) => {
    const result = [];
    let bundle = [];
    items.forEach((item, index) => {
      bundle.push(item);
      if ((index + 1) % bundleSize === 0 || index === items.length - 1) {
        result.push(bundle);
        bundle = [];
      }
    });
    return result;
  };

  return (
    <>
      <ApplicationCardInfoModal
        setSelectedApplication={setSelectedApplication}
        selectedApplication={selectedApplication}
      ></ApplicationCardInfoModal>
      <Carousel
        key={carouselKey}
        nextIcon={<IconSvg height={15} width={8} icon={"carousel-next"} />}
        prevIcon={<IconSvg height={15} width={8} icon={"carousel-prev"} />}
        className={"custom-carousel"}
      >
        {carouselItems?.map((carouselItem, carouselIndex) => {
          return (
            <Carousel.Item className={"py-4 px-3"} key={carouselIndex}>
              <Row className={"m-0"}>
                {carouselItem.map((companyCredit, creditIndex) => {
                  return (
                    <Col xs={12} sm={6} md={6} lg={4} xxl={3} xxxl={2} key={companyCredit.companyCreditsId || creditIndex}>
                      <ApplicationCard companyCredit={companyCredit} setSelectedApplication={setSelectedApplication}>
                        <div className={"info-container"}>
                          <div className={"absolute-top-right info-wrapper "}>
                            <IconSvg icon={"infoButton"} />
                          </div>

                          <div className={"info-content  bg-white overflow-y-auto z-3 pe-0"}>
                            <PerfectScrollbar>
                              <ul className={"text-12 mb-0"}>
                                {companyCredit.assessment.inventories?.map((inventory, invIndex) => (
                                  <li key={`inv-${inventory.id || invIndex}`} className={"mb-3"}>
                                    <strong>{inventory.name}</strong>
                                    <ul>
                                      {inventory.scopes.map((scope, scopeIndex) => (
                                        <li key={`inv-scope-${inventory.id}-${scope.id || scopeIndex}`}>
                                          {scope.name}
                                          {scope.subScopes && scope.subScopes.length > 0 && (
                                            <ul>
                                              {scope.subScopes.map((subScope, subIndex) => (
                                                <li key={`inv-sub-${inventory.id}-${scope.id}-${subScope.id || subIndex}`}>{subScope.name}</li>
                                              ))}
                                            </ul>
                                          )}
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                ))}
                              </ul>

                              <ul className={"text-12 mb-0"}>
                                {companyCredit.assessment.tests?.map((test, testIndex) => (
                                  <li key={`test-${test.id || testIndex}`} className={"mb-3"}>
                                    <strong>{test.name}</strong>
                                    <ul>
                                      {test.scopes.map((scope, scopeIndex) => (
                                        <li key={`test-scope-${test.id}-${scope.id || scopeIndex}`}>
                                          {scope.name}
                                          {scope.subScopes && scope.subScopes.length > 0 && (
                                            <ul>
                                              {scope.subScopes.map((subScope, subIndex) => (
                                                <li key={`test-sub-${test.id}-${scope.id}-${subScope.id || subIndex}`}>{subScope.name}</li>
                                              ))}
                                            </ul>
                                          )}
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                ))}
                              </ul>
                            </PerfectScrollbar>
                          </div>
                        </div>

                        <ApplicationCardContent companyCredit={companyCredit}></ApplicationCardContent>
                      </ApplicationCard>
                    </Col>
                  );
                })}
              </Row>
            </Carousel.Item>
          );
        })}
        {carouselItems.length === 0 && (
          <Carousel.Item className={"py-4 px-3"}>
            <Row className={"m-0"}>
              <Col xs={12} sm={6} md={6} lg={4} xxl={3} xxxl={2}>
                <ApplicationCard isDisabled={true}>
                  <div className={"absolute-top-right info-wrapper"}>
                    <IconSvg icon={"infoButton"} />
                  </div>
                  <div className={"info-content bg-success"}></div>
                  <Row className={"justify-content-center h-100"}>
                    <Col xs={"auto"} className={"align-content-center text-center text-30"}>
                      {t("noApplicationsAssigned")}
                    </Col>
                  </Row>
                </ApplicationCard>
              </Col>
            </Row>
          </Carousel.Item>
        )}
      </Carousel>
    </>
  );
};
export default ApplicationCardList;
